import { Injectable } from '@angular/core';
import { DataCollections } from '@osos/shared/api';
import {
  CollectionPresenterModel,
  DataTypeEnum,
  RefProperty,
} from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class LovParserV1Service extends ParserBase<
  DataCollections,
  CollectionPresenterModel
> {
  constructor() {
    super(DataCollections, CollectionPresenterModel, 1);
  }

  getPresenterModel(model: DataCollections): CollectionPresenterModel {
    const presenter = {
      specificationVersion: this.version,
      id: model.id,
      isImplicit: model.isImplicit,
      name: model.name,
      description: model.description,
      dataEntity: model.dataEntity,
      visibility: model.visibility,
      items: model.items,
      dataEntityType: this.mapDataEntityType(model.dataEntity),
      collectionType: model.collectionType,
      icon: model.icon,
      module: model.module,
      relatedToUser: model.relatedTo?.user,
      relatedToView: model.relatedTo?.view as RefProperty,
    } satisfies CollectionPresenterModel;

    //TODO: to be ignored
    // presenter.configuration = model.configuration;
    return presenter;
  }

  getDataModel(presenter: CollectionPresenterModel): DataCollections {
    const model = {
      specificationVersion: this.version,
      description: Object.keys(presenter.description ?? {}).every(
        (k) => !presenter.description[k],
      )
        ? undefined
        : presenter.description,
      name: presenter.name,
      dataEntity: presenter.dataEntity,
      visibility: presenter.visibility,
      collectionType: presenter.collectionType,
      items: presenter.items,
      icon: presenter.icon,
      module: presenter.module || undefined,
    } as DataCollections;
    return model;
  }

  private mapDataEntityType(dataEntity: string): DataTypeEnum {
    const map = {
      ADTString: DataTypeEnum.Text,
      ADTNumber: DataTypeEnum.Number,
      ADTDate: DataTypeEnum.Date,
      ADTTime: DataTypeEnum.Time,
      ADTDatetime: DataTypeEnum.DateTime,
    };
    return map[dataEntity] ?? DataTypeEnum.Entity;
  }
}
